import { FC, useMemo, useState } from "react";

import { IEventStatus, IIconBandSetting } from "Bands/types";
import { Icon } from "shared/styles";
import { getEventStatusIcons, getEventTypeIcon } from "Bands/utils";

import { TypeIconContainer, StatusIconContainer } from "./styles";
import { Tooltip } from "shared/components/Tooltip/Tooltip";

interface EventHeaderProps {
  type: string | IIconBandSetting;
  status: IEventStatus;
  eventTypes?: IIconBandSetting[];
}

export const EventTypeIcon: FC<EventHeaderProps> = ({ type, status, eventTypes }) => {
  const typeIcon = useMemo(() => getEventTypeIcon(type, eventTypes), [eventTypes, type]);

  const statusIcon = useMemo(() => getEventStatusIcons(status), [status]);
  const [referenceElement, setReferenceElement] = useState<Element | null>();

  return (
    <>
      <TypeIconContainer ref={setReferenceElement}>
        <Icon size="xxl" as={typeIcon} />
        <StatusIconContainer>
          <Icon size="m" as={statusIcon.icon} color={statusIcon.color} />
        </StatusIconContainer>
      </TypeIconContainer>
      <Tooltip
        content={`${typeof type === "object" ? type.label : type} (${status})`}
        referenceElement={referenceElement}
        maxWidth={200}
      />
    </>
  );
};
